
import { FETCH_TRIPS_REQUEST, FETCH_TRIPS_SUCCESS, FETCH_TRIPS_ERROR,FETCH_TRIPS_CLEAR } from './searchTripsConstantTypes'


const initialTripState = {
    loading: true,
    tripdata: {
        },
    error: ''
}
export const searchTripsReducer = (state = initialTripState, action) => {
    
    switch (action.type) {
        case FETCH_TRIPS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_TRIPS_SUCCESS:
           
            return {
                ...state,
                tripdata: action.payload,
                loading: false,
                error: ''
            }
        case FETCH_TRIPS_ERROR:
            return {
                ...state,
                tripdata: {},
                loading: false,
                error: action.payload
            }
            case FETCH_TRIPS_CLEAR:
            return {
                ...state,
                tripdata: {},
                loading: false,
                error: ''
            }
        default:
           return state;
    }
}

